
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import Tag from '~/components/atoms/Tag.vue'
import SexualitySlider from '~/components/molecules/SexualitySlider.vue'
import { GenderInfoList } from '~/types/api/result'

export default Vue.extend({
  components: {
    Tag,
    SexualitySlider,
  },
  props: {
    genderInfoList: {
      type: Object,
      required: true,
    } as PropOptions<GenderInfoList>,
  },
  computed: {
    summaries() {
      const genderInfoList: any = this.genderInfoList
      if (genderInfoList.gender.summary === '') {
        return genderInfoList.otherGenders
          .filter((g) => g.summary !== '')
          .map((g) => g.summary)
          .join('、')
      } else {
        return genderInfoList.otherGenders
          .filter((g) => g.summary !== '')
          .map((g) => g.summary)
          .concat([genderInfoList.gender.summary])
          .join('、')
      }
    },
    genderTypeClass() {
      const genderInfoList = this.genderInfoList
      return {
        'sexualities--sex': genderInfoList.genderTypeCode === 'sex',
        'sexualities--genderIdentity': genderInfoList.genderTypeCode === 'gender_identity',
        'sexualities--genderExpression': genderInfoList.genderTypeCode === 'gender_expression',
        'sexualities--sexualOrientation': genderInfoList.genderTypeCode === 'sexual_orientation',
        'sexualities--romanticOrientation': genderInfoList.genderTypeCode === 'romantic_orientation',
      }
    },
  },
})
